import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ContactFormData {
  name: string
  email: string
  phone: string
  company: string
  inquiryType: string
  message: string
}

interface ContactState {
  formData: ContactFormData
  isSubmitting: boolean
  isSuccess: boolean
  error: string | null
}

const initialState: ContactState = {
  formData: {
    name: '',
    email: '',
    phone: '',
    company: '',
    inquiryType: '',
    message: '',
  },
  isSubmitting: false,
  isSuccess: false,
  error: null,
}

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    updateFormData: (state, action: PayloadAction<Partial<ContactFormData>>) => {
      state.formData = { ...state.formData, ...action.payload }
    },
    setSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.isSuccess = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    resetForm: (state) => {
      state.formData = initialState.formData
      state.isSubmitting = false
      state.isSuccess = false
      state.error = null
    },
  },
})

export const { updateFormData, setSubmitting, setSuccess, setError, resetForm } = contactSlice.actions
export default contactSlice.reducer